import { useEffect, useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import WatDoenWe from "@/components/site/WatDoenWe";
import Pricing from "@/components/site/Pricing";
import Gallery from "@/components/site/Gallery";
import BeforeAfter from "@/components/site/BeforeAfter";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

export default function LandingPage() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    document.title = "De Toiletman — Toiletrenovatie in 3 dagen v.a. €1200";
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900 font-body" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <WatDoenWe />
        <Pricing />
        <Gallery />
        <BeforeAfter />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      {mounted ? null : null}
    </div>
  );
}
